import { useQuery } from 'react-query'

import { type SecondaryCategory } from '@webapp/core/entities/internal/SecondaryCategory'
import { expenseReportQueryConfig } from '@webapp/modules/expense/query-configs/expenseReport'

type UseQueryReviseFormDefaultsReturn = {
  data: { defaultDepartment: Nullable<SecondaryCategory> } | undefined
  isLoading: boolean
  error: Error | null
}

export const useQueryReviseFormDefaults = (
  locationId: number,
  departmentId: number
): UseQueryReviseFormDefaultsReturn => {
  const config = expenseReportQueryConfig.reviseFormDefaults(
    locationId,
    departmentId
  )

  const { data, isLoading, error } = useQuery({
    queryKey: config.queryKey,
    queryFn: config.queryFn,
    enabled: locationId > 0 && departmentId > 0,
  })

  return {
    data,
    isLoading,
    error: error as Error | null,
  }
}
